export type AddShiftOptionType =
  | 'defaultShift'
  | 'customShift'
  | 'template'
  | 'copyPeriod'
  | 'savedCustom'
  | 'duplicate'

export const ADD_SHIFT_OPTIONS = Object.freeze({
  defaultShift: 'defaultShift',
  customShift: 'customShift',
  template: 'template',
  copyPeriod: 'copyPeriod',
  savedCustom: 'savedCustom',
  duplicate: 'duplicate',
})
